import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
export default function GCHead({
  sTransItemStockObj,
  xTransItemStockShow,
  //grid saleshistory
  sToggleGrid,
  sGridSalesHistoryRowData,
  GridDataSalesHistoryColumns,
  //grid saleshistory end
  xDisableBasedOnGridDataLength,
  xErrorMsg,
  vRdxuserLoc,
  xKey,
  vRdxWmsHead,
  fonSelectedGrnType,
  sDocLoadingGrnType,
  fGrnDate,
  fLocation,
  fReason,
  sReason,
}) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0.9 }}
        columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={6} sm={6} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <CmpDatePickerField001V1
                xLabelText="Doc.Date"
                xtabIndex={"3"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fGrnDate}
                xName={"A_PostDt"}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PostDt}
              />
            </Grid>
          </Grid>
        </Grid>
        {sToggleGrid ? (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start"
            >
              <div style={{ height: 170, width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridSalesHistoryRowData}
                  columns={GridDataSalesHistoryColumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  // onRowClick={fonRowClickGridObj}
                  hideFooter
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Grid
              container
              spacing={0.9}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(xErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
              <Grid item xs={6} sm={6} md={6}>
                <CmpSelectFieldV1
                  xtabIndex={"5"}
                  xLabelText="Location"
                  xValue={vRdxWmsHead.A_Loc}
                  xOnChange={fLocation}
                  xName={"A_Loc"}
                  xData={vRdxuserLoc}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_Loc === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Loc}
                  xDisable={xDisableBasedOnGridDataLength}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <CmpSelectFieldV1
                  xLabelText="Reason"
                  xValue={vRdxWmsHead.A_Reason}
                  xOnChange={fReason}
                  xName={"A_Reason"}
                  xData={sReason}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_Reason === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Reason}
                  xDisable={false}
                  xtabIndex={"5"}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <span
                  className={
                    vRdxWmsHead.A_DocStat === "POST"
                      ? "hide-all-time"
                      : "d-flex justify-content-between align-items-center"
                  }
                >
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"Stock=" + sTransItemStockObj.RPStock}
                  />{" "}
                  &nbsp; &nbsp;
                  {xTransItemStockShow >= 0 ? (
                    <>
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={" CostPr=" + sTransItemStockObj.CostPr}
                      />
                      &nbsp;&nbsp;
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={"LPRate=" + sTransItemStockObj.LPRate}
                      />{" "}
                    </>
                  ) : (
                    <></>
                  )}
                  &nbsp; &nbsp;
                </span>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </form>
  );
}
